import { GET_ENTITLEMENTS } from "./action";

const initialState = {
  entitlements: { totalRows: 0, items: [] },
  filters: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ENTITLEMENTS:
      return { ...state, entitlements: action.payload };
    default:
      return state;
  }
};
